import React from "react";
import { IoStar } from "react-icons/io5";
import * as s from "./index.module.scss";
import OfficeBuilding from "../../../images/FreeAppraisal/office-building.svg";

const Location = () => {
  return (
    <section className={`${s.location}`}>
      <div className={s.location_wrapper}>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12088.883081749484!2d-73.9786699!3d40.7571688!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c258fe5bfb8f53%3A0x84bc2a9bebac3f46!2sManhattan%20Buyers%20Inc.%20Rolex%20Buyer%2C%20Diamond%20Buyer%2C%20Gold%20Buyer%2C%20Sell%20Watch!5e0!3m2!1sen!2slk!4v1681709411340!5m2!1sen!2slk"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title={"google-map-common"}
        ></iframe>
        <div className={s.location_details}>
          <div className={s.location}>
            <div>
              <img loading="lazy" src={OfficeBuilding.src} alt="image" />
            </div>
            <div>
              <a href="">Visit Us At xxxxx to get an Instant Appraisal</a>
              <p>590 5th Ave 10th Floor New York, NY 10036</p>
            </div>
          </div>
          <div className={s.ratings}>
            <p>Manhattan Buyers</p>
            <div className="d-flex justify-content-start align-items-center">
              <div className="me-3">
                <IoStar size="16px" />
                <IoStar size="16px" />
                <IoStar size="16px" />
                <IoStar size="16px" />
                <IoStar size="16px" />
              </div>
              <p className="mb-0">168 reviews </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;
